import React from 'react'
import '../../Css/rodapeFoot.css'




function RodapeFoot() {
    return (
        <div className='rodapeFoot'>
            <div className='rodapeFoot_container'>

            <div className='Contaniner_conteudo'><p>Conditions of UsePrivacy NoticeInterest-Based Ads© 2021</p> </div>
            <div className='Contaniner_conteudo'><p>Version 3.20.21</p></div>
            <div className='Contaniner_conteudo'><p>Tou-Aki.web.app, Inc. or its affiliatesr</p></div>

            </div>
        </div>
    )
}

export default RodapeFoot
